import { createContext, useContext, useState } from "react";

const AppContext = createContext(null);

/**
 * Pages: "home" | "products" | "about" | "contact" | "cart" | "product-detail"
 * navigate(page, cat?, product?) — product only needed for "product-detail"
 */
export function AppProvider({ children }) {
  const [page, setPage]                   = useState("home");
  const [activeCat, setActiveCat]         = useState("all");
  const [search, setSearch]               = useState("");
  const [activeProduct, setActiveProduct] = useState(null);

  const navigate = (nextPage, cat = "all", product = null) => {
    setPage(nextPage);
    setActiveCat(cat);
    if (product !== null) setActiveProduct(product);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AppContext.Provider value={{ page, activeCat, search, activeProduct, navigate, setSearch }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside <AppProvider>");
  return ctx;
}
